/**
 * Cart discount code handler — Eliwell Nutrition
 * Works with both the new cp-* cart page and the legacy cart drawer.
 * Compatible with: #cart-discount-code, #apply-discount-btn,
 *   .cart-applied-discount[data-discount-code], .remove-discount-btn[data-discount].
 */

(function () {
  'use strict';

  var activeRequest = null;

  function init() {
    initDiscountActions();
    // Re-init after cart-page.js refreshes the DOM
    document.addEventListener('cart:refreshed', function () {
      initDiscountActions();
    });
  }

  // ── Page refresh ──────────────────────────────────────────

  async function refreshCartPage() {
    try {
      var response = await fetch(window.location.pathname + '?t=' + Date.now());
      var html     = await response.text();
      var doc      = new DOMParser().parseFromString(html, 'text/html');

      // New-style cart page: swap #CartItems + #CartSummary
      var newItems   = doc.getElementById('CartItems');
      var curItems   = document.getElementById('CartItems');
      if (newItems && curItems) curItems.innerHTML = newItems.innerHTML;

      var newSummary = doc.getElementById('CartSummary');
      var curSummary = document.getElementById('CartSummary');
      if (newSummary && curSummary) curSummary.innerHTML = newSummary.innerHTML;

      var newCount = doc.querySelector('.cp-title__count');
      var curCount = document.querySelector('.cp-title__count');
      if (newCount && curCount) curCount.textContent = newCount.textContent;

      // Legacy cart page fallback (.cart__page wrapper)
      var newCart = doc.querySelector('.cart__page');
      var curCart = document.querySelector('.cart__page');
      if (newCart && curCart && !curItems) {
        curCart.innerHTML = newCart.innerHTML;
      }

      initDiscountActions();
    } catch (err) {
      console.error('[cart-discount] refresh failed', err);
    }
  }

  // ── Discount API ──────────────────────────────────────────

  async function updateDiscounts(discounts) {
    if (activeRequest) activeRequest.abort();
    activeRequest = new AbortController();

    try {
      var response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        signal: activeRequest.signal,
        body: JSON.stringify({ discount: discounts.join(',') })
      });
      return await response.json();
    } catch (err) {
      if (err.name !== 'AbortError') console.error(err);
      return null;
    } finally {
      activeRequest = null;
    }
  }

  function getExistingDiscounts() {
    return Array.from(
      document.querySelectorAll('.cart-applied-discount')
    ).map(function (el) { return el.dataset.discountCode; }).filter(Boolean);
  }

  function showLoading(show) {
    var el = document.getElementById('discount-loading');
    if (el) el.classList.toggle('hidden', !show);
  }

  function showError(show) {
    var el = document.getElementById('discount-error');
    if (el) el.classList.toggle('hidden', !show);
  }

  // ── Wire up buttons ───────────────────────────────────────

  function initDiscountActions() {
    var applyBtn = document.getElementById('apply-discount-btn');
    if (applyBtn && !applyBtn._discountBound) {
      applyBtn._discountBound = true;
      applyBtn.addEventListener('click', handleApply);
    }

    document.querySelectorAll('.remove-discount-btn').forEach(function (btn) {
      if (btn._discountBound) return;
      btn._discountBound = true;
      btn.addEventListener('click', handleRemove);
    });
  }

  async function handleApply() {
    var input = document.getElementById('cart-discount-code');
    if (!input) return;

    var code = input.value.trim();
    if (!code) return;

    var existing = getExistingDiscounts();
    if (existing.indexOf(code) !== -1) return;

    var applyBtn = document.getElementById('apply-discount-btn');
    if (applyBtn) applyBtn.disabled = true;

    showLoading(true);
    showError(false);

    var result = await updateDiscounts(existing.concat(code));

    if (
      result &&
      result.discount_codes &&
      result.discount_codes.some(function (d) {
        return d.code === code && d.applicable === false;
      })
    ) {
      showError(true);
      input.value = '';
    } else {
      await refreshCartPage();
    }

    showLoading(false);
    if (applyBtn) applyBtn.disabled = false;
  }

  async function handleRemove() {
    var code = this.dataset.discount;
    if (!code) return;

    showLoading(true);

    var remaining = getExistingDiscounts().filter(function (c) { return c !== code; });
    await updateDiscounts(remaining);
    await refreshCartPage();

    showLoading(false);
  }

  // ── Boot ──────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
